import { Link as MuiLink, Typography } from '@material-ui/core';
import { ColorDynamic, Stack } from '@superdispatch/ui';
import { Box } from '@superdispatch/ui-lab';
import { useNavigate } from 'react-router-dom';
import { PermissionIcon } from 'shared/icons/PermissionIcon';
import { useCarrierSettings } from 'shared/settings/CarrierSettingsAPI';
import styled from 'styled-components';

const Link = styled(MuiLink)`
  color: ${ColorDynamic.Blue200};
  &:hover {
    cursor: pointer;
  }
`;

export const PermissionScreen = () => {
  const { data: settings } = useCarrierSettings();
  const navigate = useNavigate();
  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      width="100%"
      height="100%"
    >
      <Box width="440px">
        <Stack align="center" space="medium">
          <PermissionIcon />
          <Stack align="center" space="xsmall">
            <Typography variant="h3">No Access</Typography>
            <Typography align="center" color="textSecondary">
              Your account isn&apos;t set up with the correct role(s) to perform
              this action.
            </Typography>
          </Stack>
          <Typography align="center" color="textSecondary">
            To gain access, ask{' '}
            {settings?.account_admin?.email && (
              <>
                account Admin at{' '}
                <Link
                  color="primary"
                  href={`mailto:${settings.account_admin.email}`}
                >
                  {settings.account_admin.email}
                </Link>{' '}
                or
              </>
            )}{' '}
            a{' '}
            <Link
              color="primary"
              onClick={() => {
                navigate({ pathname: '/users', search: 'role=operations' });
              }}
            >
              user with Operations role
            </Link>{' '}
            to update your roles.
          </Typography>
        </Stack>
      </Box>
    </Box>
  );
};
